import { Injectable } from '@angular/core';
import { ProductAgreementControllerService, SubProductDTO } from '@iota/iota-management-portal-v4-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, take, withLatestFrom } from 'rxjs';
import { AgreementActionTypes, LoadAgreementsByProduct, UpsertProductAgreement } from '../actions/agreement.actions';
import { selectedProduct } from '../store';

@Injectable()
export class AgreementEffects {
    loadAgreementsByProduct$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadAgreementsByProduct),
            mergeMap(({ productId }) =>
                this.apiService.getAllProductAgreementsByProducts([productId]).pipe(
                    take(1),
                    map((agreements) => ({
                        type: AgreementActionTypes.LoadAgreementsByProductSuccess,
                        agreements,
                        productId
                    })),
                    catchError((error) => of({ type: AgreementActionTypes.LoadAgreementsByProductFailure, error: error }))
                )
            )
        )
    );

    upsertProductAgreement$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UpsertProductAgreement),
            withLatestFrom(this.store.select(selectedProduct)),
            mergeMap(([{ agreement }, product]) => {
                let id = product.productId;

                if ((product as SubProductDTO).subProductId) {
                    id = (product as SubProductDTO).subProductId;
                }
                return this.apiService.upsertProductAgreement({ ...agreement, productId: id }).pipe(
                    take(1),
                    map(() => ({
                        type: AgreementActionTypes.LoadAgreementsByProduct,
                        productId: id
                    })),
                    catchError((error) => of({ type: AgreementActionTypes.AgreementsActionFailure, error: error }))
                );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private apiService: ProductAgreementControllerService
    ) {}
}
